import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="pt-40 pb-32 min-h-screen flex items-center justify-center">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center px-6 max-w-lg">
        <XCircle size={44} className="text-zinc-500 mx-auto mb-6" strokeWidth={1} />
        <h1 className="font-serif-display font-light text-4xl md:text-5xl text-white tracking-tight">Checkout cancelled.</h1>
        <p className="text-zinc-400 mt-4">
          No charge was made. Your order is still in the cart whenever you're ready.
        </p>
        <Link
          to="/shop"
          data-testid="back-to-shop-btn"
          className="inline-block mt-10 bg-[#C87455] text-black hover:bg-[#A65B3E] transition-colors px-8 py-4 font-mono-tech uppercase tracking-[0.2em] text-sm"
        >
          Back to the Collection
        </Link>
      </motion.div>
    </main>
  );
}
